import Vue from 'vue';

Vue.component('golfset-modal-component', {
    data() {
        return {
            showModal: false,
            handler: null,
            flight: null,
            sets: [],
            selectedSet: null,
            gender: '',
            dexterity: '',
        };
    },

    watch: {
        gender() {
            this.selectedSet = null;
        },
        dexterity() {
            this.selectedSet = null;
        },
    },

    mounted() {
        this.$modals.$on('show-modal:golfset', this.open);
    },

    computed: {
        filtered() {
            let filtered = _.filter(this.sets, { gender: this.gender, dexterity: this.dexterity });
            filtered = _.uniqBy(filtered, (e) => e.composition + e.flex + e.length);

            if (filtered.length == 1) {
                this.selectedSet = filtered[0];
            }

            return filtered;
        },
    },

    methods: {
        open(data) {
            this.sets = data.sets;
            this.flight = data.flight;
            this.handler = data.handler;
            this.showModal = true;
        },

        close() {
            this.showModal = false;
            this.handler = null;
        },

        confirmAction() {
            if (!this.selectedSet) {
                return;
            }

            if (this.handler) {
                this.handler(this.flight, this.selectedSet);
            }

            this.close();
            this.resetState();
        },

        resetState() {
            this.handler = null;
            this.flight = null;
            this.sets = [];
            this.selectedSet = null;
            this.gender = '';
            this.dexterity = '';
        },
    },
});
